var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",domProps:{"innerHTML":_vm._s(_vm.template)}})
}
var staticRenderFns = []

export { render, staticRenderFns }